import PANE from '../../../../../APP/page/pane/PANE.js';
import { footer } from '../../../../../DOM/footer/FOOTER.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { div } from '../../../../../DOM/div/DIV.js';
import { span } from '../../../../../DOM/span/SPAN.js';
import FORM, { form } from '../../../../../DOM/form/FORM.js';
import { hero } from '../../../../../COMPONENT/hero/HERO.js';
import { fieldset } from '../../../../../DOM/form/fieldset/FIELDSET.js';
import { formFieldGroup } from '../../../../../DOM/form/fieldset/formfieldgroup/FORMFIELDGROUP.js';
import { formInputText } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEXT.js';
import { HTTPMETHOD } from '../../../../../../enums/HTTPMETHOD.js';
import { legend } from '../../../../../DOM/form/fieldset/legend/LEGEND.js';
import { label } from '../../../../../DOM/form/label/LABEL.js';
import { inputText } from '../../../../../DOM/form/fieldset/field/input/inputs/INPUTTEXT.js';
import { button } from '../../../../../DOM/button/BUTTON.js';
import { SVGS } from '../../../../../SVG/SVGS.js';
import { icon } from '../../../../../SVG/icon/ICON.js';
import { navheader } from '../../../../../DOM/nav/navbar/navheader/NAVHEADER.js';
import { navfooter } from '../../../../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import CONFIRM, { confirmEl } from '../../../../../COMPONENT/dialog/confirm/CONFIRM.js';
import CONFIRM_ReviewBreach from '../../../../../APP/page/dialog/confirm/CONFIRM_ReviewBreach.js';
/** A Panel that visualizes Tabular Data */
export default class PANE_Home_List extends PANE {
    form;
    constructor(node, model) {
        console.log('Constructing PANE_Home_List');
        super(node, model);
        this.addClass('full-frame');
        this.addClass('pane-ethic-list');
        this.buildUI();
    }
    /** Asynchronously builds the UI elements for the panel.
        @returns {void}
    */
    buildUI() {
        console.log('Building Ethics Hotline List UI...');
        let config = this.getMain().getConfig();
        // Construct the UI elements
        this.hero = this.addHero(hero(undefined, undefined, div(), heading(1, '', undefined, 'EthicsHotlineGeneral', 'EthicsHotline'), heading(2, '', undefined, 'EthicsHotlineGeneral', 'ListBreaches'), text('')));
        // Search Form
        this.form = new FORM(this, form('review-breach', 'form-ethic-hotline', `${config.app.apiEndpoint}/ethics/breach/review`, HTTPMETHOD.POST));
        // Fieldset: Breach Search
        this.fsBreachSearch = this.form.addFieldset(fieldset('breach-search-fs', undefined, legend('Search')));
        this.fsBreachSearchDescription = this.fsBreachSearch.addP(text('Search by GUID'));
        this.fsBreachGuidGroup = this.fsBreachSearch.addFormFieldGroup(formFieldGroup('breachguid-group'));
        this.fsBreachGuid = this.fsBreachGuidGroup.addFormInputText(formInputText(label('Breach GUID'), inputText('breach-guid'))).setAttribute('name', 'breach-guid');
        this.fsBreachGuid.getButtonGroup().addButton(button(span('Clear'), 'clear-breach-guid', icon(SVGS.CLOSE))).on('click', () => {
            this.fsBreachGuid.getField().setValue('');
        });
        this.fsBreachGuid.getButtonGroup().addButton(button(span('Search'), 'search-breach-guid', icon(SVGS.CHECKMARK))).on('click', () => {
            this.searchForBreach(this.searchBtn);
        });
        // Footer
        this.footer = this.addFooter(footer());
        this.footerCite = this.footer.addCite(text(''));
        this.footerCite.addSpan(span('', undefined, 'Generic', 'LastModified'));
        this.footerCite.addSpan(span(': 2025-12-17'));
        this.getMain().translate();
        // console.log('Ethics Hotline Review UI built successfully.', this.getMain().getConfig());
    }
    /** Triggers a CONFIRM dialog
        @param {EL<HTMLElementModel>} caller - The element that triggered the confirmation
        @return void
    */
    searchForBreach(caller) {
        let breachGuid = this.fsBreachGuid.getField().getValue();
        if (breachGuid === undefined || breachGuid === null || breachGuid === '') {
            new CONFIRM(this.getMain().getBody(), confirmEl('warn-invalid', 'info', caller, navheader(), navfooter(), text('Please enter a Breach GUID to search'))).show();
            return;
        }
        console.log('Searching for breach with GUID:', breachGuid);
        this.getJson(`${this.getMain().getConfig().app.apiEndpoint}/ethics/breach/review/${breachGuid}`, (response, status) => {
            console.log('Received response from Ethics Hotline Review:', response, status);
            let results = {
                results: response,
                errors: []
            };
            if (status !== 200) {
                if (status === 401) {
                    new CONFIRM(this.getMain().getBody(), confirmEl('warn-notfound', 'info', caller, navheader(), navfooter(), text('You are not authorized to review this breach. Please check your credentials and try again.'))).show();
                }
                else {
                    new CONFIRM(this.getMain().getBody(), confirmEl('warn-notfound', 'info', caller, navheader(), navfooter(), text('No breach found with the provided GUID.<br>Please check and try again.'))).show();
                }
                return;
            }
            // Show the review dialog
            let confirm = new CONFIRM_ReviewBreach(this.getMain().getBody(), confirmEl('confirm-review-breach', 'confirm-review-breach no-cancel', caller, navheader(), navfooter(), text(`Reviewing Breach: <cite>${breachGuid}</cite>`)));
            confirm.populateBreachSummary(response);
            confirm.show();
        }, HTTPMETHOD.GET, undefined, window.sessionStorage.getItem('token') || undefined);
    }
}
